import { render, staticRenderFns } from "./MainQuestionsScreen.vue?vue&type=template&id=a9743f84&scoped=true&"
import script from "./MainQuestionsScreen.vue?vue&type=script&lang=js&"
export * from "./MainQuestionsScreen.vue?vue&type=script&lang=js&"
import style0 from "./MainQuestionsScreen.vue?vue&type=style&index=0&id=a9743f84&prod&scoped=true&lang=css&"
import style1 from "./MainQuestionsScreen.vue?vue&type=style&index=1&id=a9743f84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9743f84",
  null
  
)

export default component.exports